import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { StoresList } from './components/StoresList';
import { StoreDashboard } from './components/StoreDashboard';
import FeedSearch from './components/FeedSearch';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Auth from './components/Auth';

function ProtectedApp() {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Auth />;
  }
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<StoresList />} />
        <Route path="/store/:id" element={<StoreDashboard />} />
        <Route path="/search" element={<FeedSearch />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <AuthProvider>
        <ProtectedApp />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
